module.exports = __webpack_public_path__ + "static/img/James-Tedesco.5d022ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/James-Tedesco.jpg
// module id = w4qB
// module chunks = 0